import React from 'react';
import { introData } from '../mockData';

const IntroSection = () => {
  return (
    <section className="py-20 md:py-32 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-12">
          {introData.heading}
        </h2>
        <div className="space-y-6 text-gray-700 leading-relaxed">
          {introData.paragraphs.map((paragraph, index) => (
            <p key={index} className="text-base md:text-lg">
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IntroSection;